// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  sessionId: __t.u64(),
  targetPresenceId: __t.option(__t.u64()),
  twinId: __t.string(),
  distance: __t.option(__t.f32()),
  pitch: __t.option(__t.f32()),
  message: __t.option(__t.string()),
};
